import useMobileCartPage from './useMobileCartPage'

export default useMobileCartPage
